<template>
	<div class="input-group d-flex align-items-center">
		<div class="input-group-prepend">
			<a @click="disminuir">
				<i class="icon-recurso-1 icon-masmenos"></i>
			</a>
		</div>
		<input
			v-model="localValue"
			@blur="agregarCantidad"
			@focus="backupCantidad"
			@keyup.tab="pressTab"
			@input="update"
			@keyup.enter="agregarCantidad"
			class="form-control text-right form-control-sm"
			@keydown="soloNumeros"
			ref="inputCantidad"
			type="text"
			style="z-index=0"
		/>
		<div class="input-group-append">
			<a @click="aumentar">
				<i class="icon-recurso-2 icon-masmenos"></i>
			</a>
		</div>
	</div>
</template>
<script>
//oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
//onkeydown="if(event.key==='.'){event.preventDefault();}"
	export default {
		data() {
			return {
				cantidadBackup: 0,
				localValue: this.value,				
			}
		},
		props: ["value", "articulo", "indexSelected"],
		methods: {
			soloNumeros(e){
				//console.log('tag', e.keyCode)
				//return key >= 48 && key <= 57;
				//if(e.keyCode < 96 || e.keyCode > 105){
				// 	e.preventDefault();
				// }
				if((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105) && e.keyCode !=='190'  && event.keyCode !=='110' && event.keyCode !==8 && event.keyCode !=='9' ) {
					e.preventDefault();
				}
				// else if(event.key==='.'){
				// 	event.preventDefault()
				// }
			},
			disminuir() {
				this.$emit("disminuir", this.articulo, this.cantidadBackup)
			},
			aumentar() {
				this.$emit("aumentar", this.articulo, this.cantidadBackup)
			},
			update() {				
				this.$emit("input", this.localValue)
			},
			backupCantidad() {				
				this.$refs.inputCantidad.select()
				this.cantidadBackup = this.localValue
			},
			agregarCantidad() {

				// if (this.cantidadBackup != this.localValue && this.localValue != '') {
				// 	this.$emit("agregarCantidad", this.articulo, this.cantidadBackup)
				// }
				// else{
				// 	this.value = this.cantidadBackup
				// }
				
				this.$emit("agregarCantidad", this.articulo, this.cantidadBackup)

				this.$emit("input", this.localValue)
			},
			pressTab(){
				this.$emit("pressTab", this.indexSelected)
			}
		},
		watch:{
			value(newValue){
				this.localValue = newValue
			}
		}
		
	}
</script>
<style scoped>
	.icon-trash {
		color: var(--bg-menu-blue) !important;
	}
	.icon-masmenos {
		color: #f1c240 !important;
		font-size: 28px;
	}
	.input-number {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		display: inline;
		max-width: 100px;
		min-width: 50px;
		text-align: right;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
	}
</style>